export enum ListWagerType {
  STRAIGHT_BET = 0,
  PARLAY = 1,
  TEASER = 2,
  IF_WIN = 3,
  REVERSE_WIN = 4,
  ROUND_ROBIN = 5,
  ACTION_POINTS = 6,
  IF_WIN_OR_TIE = 7,
  REVERSE_ACTION = 8,
  BLOCK = 9,
  IF_LOSE = 10,
  IF_LOSE_OR_TIE = 11,
  RACING_BET = 12,
  CARD_BET = 14,
  COMPACT_ROUND_ROBIN = 15,
  KEY_PARLAY = 16,
  COMPACT_IF_WIN = 17,
  COMPACT_IF_WIN_OR_TIE = 18,
  COMPACT_IF_LOSE = 19,
  COMPACT_IF_LOSE_OR_TIE = 20,
  COMPACT_REVERSE_WIN = 21,
  COMPACT_REVERSE_ACTION = 22,
  RAPID_BET = 23,
  eSPORT_STRAIGHT_BET = 24,
  PROPS_BUILDER = 25,
  PROPS_BUILDER_WIDGET = 26,
  PANA_APUESTAS = 27,
  STAR_SPORTS = 28,
  ULTRALIVE = 29,
  // Gaming_Art_Tech = 30,
  // COCKPIT = 31,
  // MOBADOO = 32,
  // PEGA_MAX = 33,
  // ALLIANZ_GAME_LOTTERY = 34,
  // SPORT_CAST = 35,
  // ANGUILLA_LOTTERY = 36,
}
